import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: any) => (
      <SignInPage
        {...props}
        providers={[
          {
            id: 'github',
            title: 'GitHub',
            message: 'Sign in with your Groopview-Inc GitHub account',
            apiRef: githubAuthApiRef,
          },
        ]}
      />
    ),
  },
});

const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});

export default createApp({
  features: [catalogPlugin, navModule, signInModule],
});
